export default __webpack_public_path__ + "static/media/cant_display.9cbbc111.png";